const DATA_IMPORTER_PORT = 3052;
const DATA_IMPORTER_SLUG = 'data-importer';

function getServicesBaseDomain(hostname) {
  const labels = String(hostname || '').split('.');
  if (labels.length >= 4) return labels.slice(1).join('.');
  return hostname;
}

/**
 * Build iframe URL for DataImporter RCM Data Upload (/x12-pipeline).
 * Mirrors Practice Data Manager embed logic for port 3052.
 */
export function buildDataImporterEmbedUrl({
  path = '/x12-pipeline',
  organizationId,
  lookbackDays = 90,
  destination = 'both',
  authToken,
} = {}) {
  if (typeof window === 'undefined') return '';

  const { protocol, hostname, port, origin } = window.location;
  const scheme = protocol === 'https:' || protocol === 'http:' ? protocol : 'http:';
  const isLocal = hostname === 'localhost' || hostname === '127.0.0.1';
  const isDomain =
    !isLocal && hostname && !/^(\d{1,3}\.){3}\d{1,3}$/.test(hostname);

  const envOverride = process.env.REACT_APP_DATA_IMPORTER_FRONTEND_URL;
  let base;
  if (envOverride && String(envOverride).trim().match(/^https?:\/\//i)) {
    base = String(envOverride).trim().replace(/\/$/, '');
  } else if (isDomain) {
    const customerBase = getServicesBaseDomain(hostname);
    base = `${scheme}//${DATA_IMPORTER_SLUG}.${customerBase}`;
  } else {
    base = `${scheme}//${hostname}:${DATA_IMPORTER_PORT}`;
  }

  const pathSuffix = path && path.startsWith('/') ? path : `/${path || 'x12-pipeline'}`;
  const baseUrl = `${String(base).replace(/\/$/, '')}${pathSuffix}`;

  const params = new URLSearchParams();
  if (organizationId) params.set('organization_id', organizationId);
  const token =
    authToken ||
    (typeof localStorage !== 'undefined' &&
      (localStorage.getItem('token') || localStorage.getItem('auth_token')));
  if (token) params.set('auth_token', token);
  params.set('embedded', 'true');
  params.set('lookback', String(lookbackDays));
  params.set('dest', destination);

  const saasApiBase =
    port === '3120' || (!port && !isLocal)
      ? origin.replace(/\/$/, '')
      : isLocal
        ? `${scheme}//${hostname}:8001`
        : origin.replace(/\/$/, '');
  if (saasApiBase) params.set('saas_api_base', saasApiBase);

  const qs = params.toString();
  return qs ? `${baseUrl}?${qs}` : baseUrl;
}

export const ONBOARDING_LOOKBACK_OPTIONS = [30, 60, 90];

export const ONBOARDING_DESTINATION_PRESETS = {
  operational: {
    label: 'Operational (HOT)',
    hint: 'Denials, ERA, Work Queue',
  },
  analytics: {
    label: 'Analytics',
    hint: 'Dashboards & ML training',
  },
  both: {
    label: 'Both (recommended)',
    hint: 'Claims/ERA + analytics',
  },
};
